import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-request-detail-page',
  templateUrl: './request-detail-page.component.html',
  styleUrls: ['./request-detail-page.component.css']
})
export class RequestDetailPageComponent {
  requestid = 0;

  constructor(private readonly router: Router,private readonly route: ActivatedRoute,) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.requestid = params['id'];
      console.log(this.requestid);
    });
  }
}
